import script from "./NurseCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NurseCard.vue?vue&type=script&setup=true&lang=ts"

import "./NurseCard.vue?vue&type=style&index=0&id=54a536cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a536cf"]])

export default __exports__